import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css"; // Tailwind CSS import
import { Provider } from "react-redux";
import { store } from "./redux/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
window.addEventListener("error", (event) => {
  if (event?.message?.includes("Failed to fetch dynamically imported module")) {
    window.location.reload();
  }
});

root.render(
  // <React.StrictMode>
    <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
    </Provider>
  // </React.StrictMode>
);
